import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const OPS_CUSTOMER: AppRouteRecordRaw = {
  path: '/ops-customer',
  name: 'ops-customer',
  component: DEFAULT_LAYOUT,
  redirect: '/ops-customer/list',
  meta: {
    locale: 'menu.opsCustomer',
    requiresAuth: true,
    icon: 'icon-user-add',
    order: 6,
    hideChildrenInMenu: true,
    activeMenu: 'ops-customer',
  },
  children: [
    {
      path: 'list',
      name: 'OpsCustomer',
      component: () => import('@/views/opsCustomer/index.vue'),
      meta: {
        locale: 'menu.opsCustomer',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default OPS_CUSTOMER;
